<template>
  <div class="h-dialogContainer">
    <form id='addDev'>
      <div class="row h-row-inputBox">
        <!-- 设备类型 -->
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devType')}}:</div>
            <ejs-dropdownlist name="devType" :placeholder="devTypePlaceholder" :dataSource="typeData"
              v-model="devinfo.typeCode" :fields="typeFields" :readonly="readDeviceType"
              :change="onDeviceTypeChange" :noRecordsTemplate="noRecordsTemplate" :allowFiltering='true'
              :filtering='onFiltering' :filterBarPlaceholder="filterPlaceholder">
            </ejs-dropdownlist>
          </div>
        </div>
        <!-- 设备名称 -->
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devName')}}:</div>
            <input name="devName" class="e-input" :placeholder="devNamePlaceholder"
              type="text" v-model="devinfo.name"/>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devSoftVersion')}}:</div>
            <ejs-dropdownlist name="devSoftVersion" :placeholder="devSoftVersionPlaceholder"
              :dataSource="visionData" v-model="devinfo.softwareVersion" :fields="visionFields"
              :readonly="readSoftware" :change="onSoftVersionChange"
              :noRecordsTemplate="noRecordsTemplate">
            </ejs-dropdownlist>
          </div>
        </div>
      </div>
      <!-- IP和端口 -->
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Pm.ip')}}:</div>
            <input name="devIP" class="e-input" :placeholder="devNamePlaceholder"
              type="text" v-model="deviceIP"/>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('System.port')}}:</div>
            <input name="devPort" class="e-input" :placeholder="devNamePlaceholder"
              type="text" v-model="devicePort"/>
          </div>
        </div>
      </div>
    </form>
    <div class="h-clear-rowMg"></div>
  </div>
</template>

<script>
  import CustomDialog from '../../../common/CustomDialog';
  import { FormValidator } from '@syncfusion/ej2-vue-inputs';
  import { Query } from '@syncfusion/ej2-data';
  import { EventBus } from '../../../../plugins/eventBus';

  export default {
    name: 'addBSDevice',
    components: {
      CustomDialog,
    },
    data() {
      return {
        devTypePlaceholder: this.$t('Topo.devType'), // 设备类型
        readDeviceType: false,
        devNamePlaceholder: this.$t('Topo.devName'), // 设备名称
        devSoftVersionPlaceholder: this.$t('Topo.devSoftVersion'), // 版本placeholder
        noRecordsTemplate: this.$t('Topo.noData'),
        deviceIP: '',
        devicePort: 0,
        devinfo: {
          id: '',
          name: '',
          typeCode: 0,
          positionX: 225,
          positionY: 226,
          ipPortData: [],
          softwareVersion: '',
          displaySoftwareVersion:'',
        },
        typeData: [], // 设备码和设备类型数据源
        typeFields: { value: 'typeCode', text: 'nameKey' },
        visionData: [], // 版本和显示版本数据源
        visionFields: { value: 'softwareVersion', text: 'displaySoftwareVersion' },

        readSoftware: false,
        filterPlaceholder: this.$t('Topo.search'),  // ???
        validationOption: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            devType: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devName: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
              maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            devSoftVersion: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devIP: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: ['^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$', `${this.$t('Topo.invalidIPAddress')}`],
            },
            devPort: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: ['^\\d*$', `${this.$t('Topo.invalidInt')}`],
              range: [[1, 65535], `${this.$t('Topo.inputRangeIllegal')}`],
            },
          }
        },
      };
    },
    mounted() {
      this.bindValidate();
    },
    methods: {
      bindValidate() {
        this.formObj = new FormValidator('#addDev', this.validationOption);
      },
      validate() {
        const formStatus = this.formObj.validate();
        return formStatus;
      },
      initData() {
        this.queryDevType();
        this.devinfo = {
          id: '',
          name: '',
          typeCode: '',
          equipmentIPList: [],
          softwareVersion: '',
          displaySoftwareVersion:'',
          description: ''
        };
      },
      outputs() {
        if (!this.validate()) return;
        const flag1234 = this.threadIDMatch(this.devinfo.typeCode);
        if(!flag1234){
          this.devinfo.equipmentIPList = [];
          return;
        }
        if(this.devinfo.typeCode === 10003) {
          this.devinfo.equipmentIPList[0].service = 'mcs';
        }
        this.devinfo.equipmentIPList.push({
          id: '',
          ip: this.deviceIP,
          port: this.devicePort,
          service: '',
          processCode: '',
          equipmentId: '',
        });
        const devInfo = {
          ...this.devinfo,
          typeCode: this.devinfo.typeCode.toString(),
        };
        //添加设备
        this.axios.post('/lte/ems/topo/device/addDev', devInfo).then((response) => {
          if (!response.data) return;
          if (response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            this.closeWindow();
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          this.closeWindow();
        });
      },
      onDeviceTypeChange(e) {
        const devType = parseInt(e.value);
        const This = this;
        const visionDataTemp = [];
        //添加设备时查软件版本，修改时不查
        This.readDevAttriTrunk = true;
        This.isMCSDev = false;
        This.devAttriTrunkPlaceholder = this.$t('Topo.noSelectTrunk');
        This.devSoftVersionPlaceholder = this.$t('Topo.devSelect');
        This.$axios.get(`/lte/ems/topo/device/devSoftVersion?devType=${devType}&trunkId=${'null'}`).then(response => {
          if(!response.data) return;
          if (response.status === 200 && response.data.errorCode === 'SUCCESS') {
            for(let k in response.data.resultVal) {
              visionDataTemp.push({
                softwareVersion: k,
                displaySoftwareVersion: response.data.resultVal[k]
              })
            }
          This.visionData = visionDataTemp;
          } else {
            This.visionData = [];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      },
      // ondevAttriTrunk() {
      //   const This = this;
      //   const trunkListTemp=[];
      //   This.$axios.get('/lte/ems/topo/trunk/findAllTrunks').then(response => {
      //     if(response.data === undefined) {
      //       return;
      //     }
      //     if(response.status === 200) {
      //       if (response.data.errorCode === 'SUCCESS') {
      //         for(var i in response.data.resultVal){
      //           trunkListTemp.push({
      //             clusterId:response.data.resultVal[i].id + '',
      //             trunkName:response.data.resultVal[i].name
      //           })
      //         };
      //         trunkListTemp.push({
      //           clusterId: 'FFFF',
      //           trunkName:this.$t('Topo.noAttriTrunk'),
      //         });
      //         This.trunkList = trunkListTemp;
      //       } else {
      //         This.trunkList=[];
      //         EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
      //       }
      //     }
      //   });
      // },

      // ondevAttriTrunkChange(e) {
      //   const This = this;
      //   if(e.value !== null ||this.devinfo.typeCode === 10003) {
      //     let trunkId =  e.value;
      //     if(e.value === 'FFFF'){
      //       trunkId  = 'null';
      //       This.devinfo.clusterId = 'null';
      //     }
      //     const visionDataTemp=[];
      //     This.$axios.get(`/lte/ems/topo/device/devSoftVersion?devType=${This.devinfo.typeCode}&trunkId=${trunkId}`).then(response => {
      //       if(!response.data)
      //         return;
      //       if (response.status === 200 && response.data.errorCode === 'SUCCESS') {
      //         for(let k in response.data.resultVal){
      //           visionDataTemp.push({
      //             softwareVersion:k,
      //             displaySoftwareVersion:response.data.resultVal[k]
      //           })
      //         }
      //         This.visionData = visionDataTemp;
      //       } else {
      //         This.visionData = [];
      //         EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
      //       }
      //     });
      //   }
      // },
      onSoftVersionChange(e){
        if(e.itemData) {
          this.devinfo.displaySoftwareVersion = e.itemData.displaySoftwareVersion;
        }
      },
      closeWindow() {
        this.$emit('close');
      },

      // 新建设备时去后台查设备类型
      queryDevType() {
        const This = this;
        const params={ };
        This.$axios.get('/lte/ems/topo/device/devType',params).then((response) => {
          if(!response.data) return;
          if (response.status === 200 && response.data.errorCode === 'SUCCESS') {
            This.typeData = response.data.resultVal;
          } else {
            This.typeData = [];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      },
      threadIDMatch(value) {
        // 设备类型与进程号绑定
        const This = this;
        if (value === 10001 ) {
          this.devinfo.equipmentIPList[0].service = 'epc';
        }
        if (value === 10002) {
          this.devinfo.equipmentIPList[0].service = 'ims';
        }
        if (value === 10003) {
          this.devinfo.equipmentIPList[0].service = 'mcs';
        }
        if (value === 10004 || value === 10008) {
          this.devinfo.equipmentIPList[0].service = 'enodeb';
        }
        if (value === 10005 || value === 10006) {
          const len = this.devinfo.equipmentIPList.length;
          if (len === 1) {
            this.devinfo.equipmentIPList[0].service = 'enodeb';
          }
          if (len === 2) {
            this.devinfo.equipmentIPList[0].service = 'enodeb';
            this.devinfo.equipmentIPList[1].service = 'epc';
            if (this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[1].ip &&
              this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[1].port ){
              EventBus.$emit('toast', {type: 'error', content: this.$t('Topo.ipPortDup')});
              return false;
            }
          }
          if(len === 3) {
            this.devinfo.equipmentIPList[0].service = 'enodeb';
            this.devinfo.equipmentIPList[1].service = 'etc';
            this.devinfo.equipmentIPList[2].service = 'etc';
            if ((this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[1].ip &&
              this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[1].port) ||
              (this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[2].ip &&
                this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[2].port) ||
              (this.devinfo.equipmentIPList[1].ip === this.devinfo.equipmentIPList[2].ip &&
                this.devinfo.equipmentIPList[1].port === this.devinfo.equipmentIPList[2].port)) {
              EventBus.$emit('toast', {type: 'error', content: this.$t('Topo.ipPortDup')});
              return false;
            }
          }
        }
        if (value === 10007) {
          this.devinfo.equipmentIPList[0].service = 'bpdt';
        }
        return true;
      },

      onFiltering(e){
        let query = new Query();
        query = (e.text !== '') ? query.where('nameKey', 'startswith', e.text, true) : query;
        e.updateData(this.typeData, query);
      },
    }
  };
</script>

